import { render, staticRenderFns } from "./HistoryBlock.vue?vue&type=template&id=6cd5cb12&scoped=true&"
import script from "./HistoryBlock.vue?vue&type=script&lang=js&"
export * from "./HistoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBlock.vue?vue&type=style&index=0&id=6cd5cb12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd5cb12",
  null
  
)

export default component.exports